module.exports = __webpack_public_path__ + "static/img/testimony (30).8568cf33.jpg";